import styled from 'styled-components';
import { Link } from 'gatsby';

export const Secondary = styled.div`
  &.secondary {
    padding-left: ${({ dir }) => (dir === 'rtl' ? '0px' : '100px')};
    padding-right: ${({ dir }) => (dir === 'rtl' ? '100px' : '0px')};
    position: absolute;
    left: 0;
    top: 50px;
    display: flex;
    width: 100%;
    z-index: 109;
    transition: all 0.3s;
    height: 142px;

    .logo {
      &[dir='rtl'] {
        padding: 10px 0 0 15px;
        justify-content: flex-start;

        @media (max-width: 1199px) {
          padding: 10px 15px 0 15px;
        }
      }
    }

    &.secondary-page-nav {
      .logo {
        &[dir='rtl'] {
          justify-content: center;
        }
        .dwtclogo {
          background-image: url(/svg/sprites.svg#dwtclogo);
        }
      }

      .s-menu {
        padding: 20px 0;

        .sec-link {
          .menua-link {
            &[aria-current='page'],
            &:hover {
              color: ${(props) => props.hover};
            }
          }

          @media (min-width: 1100px) {
            li:last-child {
              a.services {
                color: #1b7bdd;
              }
            }
          }
        }

        @media (min-width: 1100px) {
          a {
            color: #333;

            small {
              display: none;
            }
          }

          .title-has-no-children,
          .no-child {
            .menua-link.about-us-page {
              &[aria-current='page'] {
                color: ${(props) => props.hover || '#1b7bdd'} !important;
              }
            }
          }
        }

        li {
          &:hover {
            z-index: 50;
          }

          @media (min-width: 1100px) {
            border-color: #ebebeb;

            & > a {
              padding: 6px 0 24px;

              &[aria-current='page'],
              &:hover {
                color: ${(props) => props.hover};
              }
            }

            &.has-submenu {
              & > a {
                &[aria-current='page'],
                &:hover {
                  color: ${(props) => props.hover};

                  &:after {
                    border-color: ${(props) => (props.color ? props.color : 'transparent')};
                    bottom: 10px;
                  }

                  & + i + .third-level-menu {
                    z-index: 32;
                    visibility: visible;
                    opacity: 1;
                  }
                }
              }

              &.activemenu {
                & > a {
                  color: ${(props) => props.color};

                  &[aria-current='page'],
                  &:hover {
                    color: ${(props) => props.hover};
                  }

                  &:after {
                    border-color: ${(props) => (props.color ? props.color : 'transparent')};
                    bottom: 10px;
                  }
                }

                .third-level-menu {
                  z-index: 31;
                  visibility: visible;
                  opacity: 1;
                }
              }
            }
          }
        }

        .third-level-menu {
          @media (max-width: 1099px) {
            max-height: none;
          }

          @media (min-width: 1100px) {
            background: #f5f5f5;

            a {
              &[aria-current='page'],
              &:hover {
                color: ${(props) => props.hover};
              }
            }
          }
        }
      }
    }

    @media (max-width: 1399px) {
      padding-left: ${({ dir }) => (dir === 'rtl' ? '0px' : '50px')};
      padding-right: ${({ dir }) => (dir === 'rtl' ? '50px' : '0px')};
    }

    @media (max-width: 1299px) {
      padding-left: ${({ dir }) => (dir === 'rtl' ? '0px' : '15px')};
      padding-right: ${({ dir }) => (dir === 'rtl' ? '15px' : '0px')};
    }

    @media (max-width: 1199px) {
      padding-left: ${({ dir }) => (dir === 'rtl' ? '0px' : '0px')};
      padding-right: ${({ dir }) => (dir === 'rtl' ? '0px' : '0px')};
    }

    @media (max-width: 1099px) {
      padding: 50px 0 0;
      height: 165px;
      justify-content: space-between;
      top: 0;
    }

    @media (max-width: 1030px) {
      position: absolute;
      z-index: 9999;
      top: 50px !important;
      padding: 0px;
      height: 115px;
    }
  }
  &.fix {
    .logo {
      justify-content: center;
    }
    .title-has-no-children:hover .menu-has-no-children {
      position: absolute;
      top: 100%;
      left: 0;
      padding: 1rem 0;
      width: 100%;
      display: flex;
      z-index: 100;
      background-color: #fff;
      height: 50px;
    }
  }
`;

export const NavToggle = styled(Link)`
  &.toggleBtn {
    display: none;

    .icon-bar {
      display: block;
      height: 3px;
      width: 25px;
      background: #333;

      & + .icon-bar {
        margin-top: 5px;
      }

      @media (max-width: 1200px) {
        background: #fff;
      }

      @media (max-width: 1099px) {
        background: #000;
      }
    }

    @media (max-width: 1099px) {
      height: 115px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      padding: 0 20px;

      &.free-zone {
        .icon-bar {
          background: #fff;
        }
      }
    }
    @media (max-width: 767px) {
      height: 92px;

      .icon-bar {
        height: 2px;
        width: 20px;

        & + .icon-bar {
          margin-top: 4px;
        }
      }
    }
  }
`;

export const Wrapper = styled.div`
  &.s-menu {
    @media (min-width: 1100px) {
      width: 100%;
      position: relative;
    }

    ul > li a {
      display: flex;
      flex-flow: column;
      justify-content: center;
      font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : '')};

      &[aria-current='page'],
      &:hover {
        color: ${(props) => props.hover};
      }

      @media (max-width: 1280px) {
        justify-content: start;
      }

      @media (max-width: 1099px) {
        width: fit-content;
      }

      small {
        max-width: 142px;
        font-size: 100%;
        margin-top: 1rem;
        text-transform: none;
        display: block;
        font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : '')};
        @media (min-width: 1100px) {
          height: 40px;
        }
        @media (max-width: 1099px) {
          display: none;
        }
      }
    }

    @media (max-width: 1099px) {
      position: fixed;
      width: 100%;
      height: auto;
      top: 0;
      left: ${({ dir }) => (dir === 'rtl' ? '' : '-100%')};
      right: ${({ dir }) => (dir === 'rtl' ? '-100%' : '')};
      background: #262626;
      display: flex;
      flex-flow: column;
      padding-top: 38px;
      transition: 1s;
      padding-bottom: 3.4rem;
      z-index: 1000;

      &.show {
        left: ${({ dir }) => (dir === 'rtl' ? '' : '0!important')};
        right: ${({ dir }) => (dir === 'rtl' ? '0!important' : '')};

        &:before {
          content: '';
          display: block;
          background-color: #333;
          height: 100px;
          width: 100%;
          position: absolute;
          top: -20px;
          z-index: 1
        }
      }
    }
    @media (max-width: 575.98px) {
      width: 100%;
      top: 0;
      height: auto;
    }
    @media (max-width: 575.98px) {
      &.show {
        width: 100%;
      }
    }
  }
`;

export const SecondaryContainer = styled.div`
  transition: all 0.3s;

  &.sec-menu {
    position: absolute;
    display: none;
    justify-content: space-between;
    width: 70%;
    padding: 20px 0 0;

    &.active {
      display: flex;
    }

    @media (min-width: 1100px) {
      width: 100%;
      padding-right: ${({ dir }) => (dir === 'rtl' ? '0px' : '70px')};
    }

    @media (max-width: 1099px) {
      position: relative;
      flex-flow: column;
      width: 100%;
      padding: 27px 0 0;
    }
  }
`;

export const SecondaryLinkUl = styled.ul`
  &.sec-link {
    display: flex;
    li {
      &:nth-child(2) {
        a {
          &:after {
            display: none;
          }
        }
      }
      &:nth-child(5) {
        a {
          &:after {
            display: none;
          }
        }
      }
    }

    @media (max-width: 1099px) {
      flex-flow: column;
      padding: 10px 25px;
      background: #333;
    }
    @media (min-width: 1100px) {
      &:hover {
        .activemenu {
          .third-level-menu {
            opacity: 0;
            visibility: hidden;
          }
        }
      }

      .activemenu {
        &:hover {
          .third-level-menu {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }
  }
`;

export const SecondaryLink = styled.li`
  padding: 0 36px;
  border-left: 1px solid #fff;
  display: flex;

  &:first-child {
    @media (min-width: 1100px) {
      border-left: ${({ dir }) => (dir === 'rtl' ? '1px solid #fff' : 'none')};
      padding-left: ${({ dir }) => (dir === 'rtl' ? '' : '18px')};
      padding-right: ${({ dir }) => (dir === 'rtl' ? '18px' : '')};
    }
  }

  &:last-child {
    border-left: ${({ dir }) => (dir === 'rtl' ? 'none' : '')};
  }

  &.title-has-no-children,
  &.no-child {
    .menua-link {
      &[aria-current='page'] {
        @media (min-width: 1100px) {
          color: ${(props) => props.hover} !important;
        }
        @media (max-width: 1099px) {
          color: #fff;
        }
      }

      &:after {
        display: none;
      }
    }
  }

  @media (max-width: 1600px) {
    padding: 0px 25px;
  }

  @media (max-width: 1450px) {
    padding: 0 19px;
  }

  @media (max-width: 1099px) {
    position: relative;
    flex-flow: column;
    border-left: 0!important;
    border-right: 0!important;
    padding: 10px 2px;

    &.has-submenu {
      padding: 10px 2px;

      & > a {
        &[dir=ltr] {
          font-weight: 500;
        }
        padding-top:2px;
        padding-bottom: 2px;
      }
    }

    &:not(:last-child) {
      border-bottom: 1px solid #666;
    }
  }

  &.has-submenu {
    &.activemenu {
      & > a {
        @media (max-width: 1099px) {
          padding-left: 18px;
          padding-right: 18px;
          
        }
      }
    }

    & > a {
      position: relative;
      z-index: 1;
      
      @media (max-width: 1099px) {
        max-width: calc(100% - 34px);
        width: fit-content;
      }

      &[aria-current='page'] {
        @media (min-width: 1100px) {
          color: ${(props) => props.hover} !important;
        }
        @media (max-width: 1099px) {
          color: #fff;
          padding-left: 18px;
          padding-right: 18px;
          padding-top: 5px;
        }
      }

      &:hover {
        & + i + .third-level-menu {
          z-index: 32;
          visibility: visible;
          opacity: 1;

          @media (max-width: 1099px) {
            visibility: hidden;
            opacity: 0;
          }
        }
      }

      @media (min-width: 1100px) {
        &:after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: ${({ dir }) => (dir === 'rtl' ? '' : '0')};
          right: ${({ dir }) => (dir === 'rtl' ? '0' : '')};
          display: inline-block;
          border: solid transparent;
          border-width: 0 1px 1px 0;
          padding: 3px;
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          transition: 0.5s;
        }
      }
    }

    &:hover {
      & > .third-level-menu {
        z-index: 31;
        visibility: visible;
        opacity: 1;

        @media (max-width: 1099px) {
          visibility: hidden;
          opacity: 0;
        }
      }

      @media (min-width: 1100px) {
        & > a:after {
          border-color: #fff;
        }
        .third-level-menu {
          visibility: visible;
          opacity: 1;
        }
      }
    }

    .togl_icn-sz {
      width: 36px;
      height: 24px;
      cursor: pointer;
      display: none;
      position: absolute;
      z-index: 3;
      &:after {
        top: 5px;
      }
      &[dir='rtl'] {
        left: 2px;
      }
      &[dir='ltr'] {
        right: 2px;
      }
      

      @media (max-width: 1099px) {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &:after {
        @media (max-width: 1099px) {
          content: '';
          display: inline-block;
          border: solid #fff;
          border-width: 0 1.5px 1.5px 0;
          padding: 4px;
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          transition: 0.5s;
        }
      }
    }

    &.active {
      @media (max-width: 1099px) {
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 42px;
          background: #3d3d3d;
        }

        a {
          color: #fff;
        }

        &:after {
          transform: rotate(225deg);
        }

        .third-level-menu {
          max-height: 300px;
          padding: 0.5rem 0;
          visibility: visible;
          opacity: 1;

          a {
            color: #fff;
          }
        }
      }
    }
  }
  &.activemenu {
    @media (max-width: 1099px) {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        bottom: 0;
        background: #3d3d3d;
      }
    }
    .third-level-menu {
      @media (max-width: 1099px) {
        padding: 0.5rem 15px;
        max-height: 300px !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative;

        a {
          font-size: 11px;
        }
      }

      .active {
        @media (max-width: 1099px) {
          background: #3d3d3d;
          font-weight: 500;
          text-decoration: underline;
        }
      }
    }
  }
`;

export const TransparentBg = styled.div`
  opacity: 0.5;
  background-color: #ccc;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 25;
`;

export const Submenu = styled.div`
  &.third-level-menu {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    top: 100%;
    left: 0;
    padding: 1rem 0;
    width: 100%;
    display: flex;
    z-index: 30;

    @media (max-width: 1099px) {
      display: block;
      width: fit-content;
      max-height: 1px;
      height: auto;
      transition: 0s;
      padding: 0 0;
      top: 0;
      /* flex-flow: column; */

      &.show {
        position: relative;
      }
    }

    .active {
      @media (min-width: 1025px) {
        color: rgb(206, 68, 91);
        text-decoration: underline;
        font-family: ${({ dir }) =>
          dir === 'rtl' ? 'GESSTwoDWTCLight, sans-serif !important' : ''};
      }
    }

    a {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif !important' : '')};
    }
  }

  &.show {
    @media (max-width: 1099px) {
      padding: 0.5rem 0;
      max-height: 300px !important;
      visibility: visible !important;
      opacity: 1 !important;
      transition: 1s;
    }
  }
`;

export const SubmenuLink = styled(Link)`
  &[dir='ltr'] {
    padding: 0 2rem 0 1rem;
  }

  &[dir='rtl'] {
    padding: 0 1rem 0 2rem;
  }

  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 1099px) {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
  }
`;
